// src/components/ContactSection.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";

export default function ContactSection() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [toast, setToast] = useState({ show: false, text: "" });

  const showToast = (text) => {
    setToast({ show: true, text });
    setTimeout(() => {
      setToast({ show: false, text: "" });
    }, 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !subject || !message) {
      setError("Por favor completa todos los campos.");
      return;
    }

    setError("");

    const formData = new FormData();
    formData.append("tipo", "contacto");
    formData.append("name", name);
    formData.append("email", email);
    formData.append("subject", subject);
    formData.append("message", message);

    try {
      const response = await fetch("https://fariaslegal.ar/sendmail.php", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setSent(true);
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");

        showToast("Mensaje enviado con éxito. Te responderemos a la brevedad.");
      } else {
        setError("Hubo un error al enviar el mensaje.");
      }
    } catch (err) {
      setError("No se pudo conectar con el servidor.");
    }
  };

  return (
    <section id="contacto" className="bg-white py-20 border-t border-accent/30">
      {/* TOAST */}
      {toast.show && (
        <div
          className="fixed top-5 right-5 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg z-50"
        >
          {toast.text}
        </div>
      )}

      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12">

        {/* --- INFORMACIÓN + MAPA --- */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-6">
            Contacto & Ubicación
          </h2>

          <h4 className="text-xl font-semibold mb-2 text-primary">
            Estudio Jurídico Farías
          </h4>

          <p className="text-gray-700 mb-1">
            Álvarez Rodríguez 146, Junín (6000) – Buenos Aires
          </p>

          <p className="text-gray-700 mb-4">
            Tel: (0236) 444 7097 / 442 2465 — Cel: (236) 459 7021
          </p>

          <div className="mt-6 rounded-xl overflow-hidden shadow-lg border border-accent/40">
            <iframe
              title="Mapa Estudio Jurídico Farías"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3273.4575180796204!2d-60.9425603!3d-34.5947164!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bb8f5531c19dfb%3A0xf2ce9d53cd6aa51d!2sAlvarez%20Rodriguez%20146%2C%20Jun%C3%ADn%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1700000000000"
              width="100%"
              height="260"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>
        </motion.div>

        {/* --- FORMULARIO --- */}
        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white p-8 rounded-xl shadow-lg border border-accent/30"
          viewport={{ once: true }}
        >
          <h3 className="text-2xl font-semibold text-primary mb-6">
            Envíanos un mensaje
          </h3>

          {error && <p className="text-red-600 mb-4">{error}</p>}
          {sent && <p className="text-green-600 mb-4">Mensaje enviado con éxito.</p>}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Nombre"
              className="border rounded-lg p-3 w-full"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <input
              type="email"
              placeholder="Email"
              className="border rounded-lg p-3 w-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <input
            type="text"
            placeholder="Asunto"
            className="border rounded-lg p-3 w-full mt-4"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />

          <textarea
            placeholder="Mensaje"
            rows="5"
            className="border rounded-lg p-3 w-full mt-4 resize-none"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>

          <button
            type="submit"
            className="mt-6 w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-primary/90 transition"
          >
            Enviar mensaje
          </button>
        </motion.form>
      </div>
    </section>
  );
}
